// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jbadg","questions":"styles_questions__XTPE1","footer":"styles_footer__2IomV"};